// extracted by mini-css-extract-plugin
module.exports = {"container":"PagePlaceholder_container__2F__8","text":"PagePlaceholder_text__1urWT","image":"PagePlaceholder_image__2dpls"};